export const isValidEmail = email => /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i.test(email);
